export default "__VITE_ASSET__5F7zxE3J__"